import { SmartComponentType } from '@/editor/panel/views/ppt-mark-panel/tag-list-config';

export const graphDataMap = {
    [SmartComponentType.TIME_AXIS]: {
        '组件标题:': '项目时间轴',
        '节点时间:1': '2023 Q1',
        '节点标题:1': '项目启动',
        '节点内容:1': '需求分析与规划',
        '关键词:1': '规划',
        '节点时间:2': '2023 Q2',
        '节点标题:2': '开发阶段',
        '节点内容:2': '核心功能开发',
        '关键词:2': '开发',
        '节点时间:3': '2023 Q3',
        '节点标题:3': '测试阶段',
        '节点内容:3': '系统测试与优化',
        '关键词:3': '测试',
        '节点时间:4': '2023 Q4',
        '节点标题:4': '上线准备',
        '节点内容:4': '部署与文档准备',
        '关键词:4': '部署',
        '节点时间:5': '2024 Q1',
        '节点标题:5': '正式上线',
        '节点内容:5': '系统正式运行',
        '关键词:5': '上线',
        '节点时间:6': '2024 Q2',
        '节点标题:6': '迭代优化',
        '节点内容:6': '功能优化与升级',
        '关键词:6': '优化',
    },
    [SmartComponentType.FLOW]: {
        '组件标题:': '项目流程图',
        '节点标题:1': '需求分析',
        '节点内容:1': '收集用户需求',
        '关键词:1': '需求',
        '节点标题:2': '系统设计',
        '节点内容:2': '架构设计与模块划分',
        '关键词:2': '设计',
        '节点标题:3': '开发实现',
        '节点内容:3': '编码与单元测试',
        '关键词:3': '开发',
        '节点标题:4': '系统测试',
        '节点内容:4': '集成测试与性能测试',
        '关键词:4': '测试',
        '节点标题:5': '部署上线',
        '节点内容:5': '生产环境部署',
        '关键词:5': '部署',
        '节点标题:6': '运维支持',
        '节点内容:6': '系统监控与维护',
        '关键词:6': '运维',
        '节点标题:7': '迭代优化',
        '节点内容:7': '功能优化与升级',
        '关键词:7': '优化',
    },
    [SmartComponentType.PYRAMID]: {
        '组件标题:': '技术能力金字塔',
        '节点标题:1': '基础技能',
        '节点内容:1': '编程语言与数据结构',
        '关键词:1': '基础',
        '节点标题:2': '框架应用',
        '节点内容:2': '主流框架使用',
        '关键词:2': '框架',
        '节点标题:3': '架构设计',
        '节点内容:3': '系统架构与设计模式',
        '关键词:3': '架构',
        '节点标题:4': '性能优化',
        '节点内容:4': '系统性能调优',
        '关键词:4': '性能',
        '节点标题:5': '安全防护',
        '节点内容:5': '系统安全与防护',
        '关键词:5': '安全',
        '节点标题:6': '团队管理',
        '节点内容:6': '项目管理与团队协作',
        '关键词:6': '管理',
        '节点标题:7': '技术创新',
        '节点内容:7': '新技术研究与创新',
        '关键词:7': '创新',
    },
    [SmartComponentType.MIND_MAP]: {
        '组件标题:': '产品功能脑图',
        '节点标题:1': '核心功能',
        '节点内容:1': '用户认证与权限管理',
        '节点标题:2': '数据管理',
        '节点内容:2': '数据存储与处理',
        '节点标题:3': '接口服务',
        '节点内容:3': 'API设计与实现',
        '节点标题:4': '监控系统',
        '节点内容:4': '系统监控与报警',
        '节点标题:5': '安全防护',
        '节点内容:5': '数据加密与防护',
        '节点标题:6': '扩展功能',
        '节点内容:6': '插件与扩展支持',
        '节点标题:7': '文档支持',
        '节点内容:7': 'API文档与使用指南',
        '节点标题:8': '测试支持',
        '节点内容:8': '自动化测试框架',
        '关键词:1': '认证',
        '关键词:2': '数据',
        '关键词:3': '接口',
        '关键词:4': '监控',
        '关键词:5': '安全',
        '关键词:6': '扩展',
        '关键词:7': '文档',
    },
    [SmartComponentType.TREE_MAP]: {
        '组件标题:': '技术栈分布',
        '父节点标题:': '前端技术',
        '子节点标题:1': 'React框架',
        '子节点标题:2': 'Vue框架',
        '子节点标题:3': 'Angular框架',
        '子节点标题:4': 'TypeScript',
        '子节点标题:5': 'Webpack',
        '子节点标题:6': 'Vite',
        '子节点标题:7': 'ESLint',
        '子节点标题:8': 'Jest',
    },
    [SmartComponentType.SWOT]: {
        '组件标题:': '项目SWOT分析',
        S标题: '技术优势',
        S内容: '团队技术实力强',
        W标题: '资源限制',
        W内容: '开发资源有限',
        O标题: '市场机会',
        O内容: '市场需求旺盛',
        T标题: '技术挑战',
        T内容: '技术更新迅速',
    },
    [SmartComponentType.QUADRANT]: {
        '组件标题:': '技术选型四象限',
        'x轴左标题:': '开发效率',
        'x轴右标题:': '运行性能',
        'y轴上标题:': '社区活跃度',
        'y轴下标题:': '学习成本',
        '第一象限标题:': '推荐技术',
        '第一象限内容:1': 'React',
        '第一象限内容:2': 'Vue',
        '第一象限内容:3': 'TypeScript',
        '第二象限标题:': '潜力技术',
        '第二象限内容:1': 'Svelte',
        '第二象限内容:2': 'SolidJS',
        '第二象限内容:3': 'Qwik',
        '第三象限标题:': '传统技术',
        '第三象限内容:1': 'jQuery',
        '第三象限内容:2': 'Backbone',
        '第三象限内容:3': 'Knockout',
        '第四象限标题:': '小众技术',
        '第四象限内容:1': 'Mithril',
        '第四象限内容:2': 'Stencil',
        '第四象限内容:3': 'Lit',
    },
    [SmartComponentType.SWIM_LANE]: {
        '组件标题:': '项目泳道图',
        '节点标题:1': '需求分析',
        '节点内容:1': '用户需求收集',
        '节点标题:2': '系统设计',
        '节点内容:2': '架构设计',
        '节点标题:3': '开发实现',
        '节点内容:3': '功能开发',
        '节点标题:4': '测试验证',
        '节点内容:4': '系统测试',
        '节点标题:5': '部署上线',
        '节点内容:5': '生产部署',
    },
    [SmartComponentType.COMPARE]: {
        '组件标题:': '技术方案对比',
        'A项目标题:1': 'React',
        'B项目标题:1': 'Vue',
        'A项目标题:2': 'Angular',
        'B项目标题:2': 'Svelte',
        'A项目标题:3': 'Next.js',
        'B项目标题:3': 'Nuxt.js',
        'A项目标题:4': 'Node.js',
        'B项目标题:4': 'Deno',
        'A项目标题:5': 'TypeScript',
        'B项目标题:5': 'JavaScript',
        'A项目标题:6': 'GraphQL',
        'B项目标题:6': 'REST',
        'A项目标题:7': 'Webpack',
        'B项目标题:7': 'Vite',
        'A项目标题:8': 'Jest',
        'B项目标题:8': 'Cypress',
        'A关键词:1': 'TypeScript',
        'B关键词:1': 'JavaScript',
        'A关键词:2': 'GraphQL',
        'B关键词:2': 'REST',
        'A关键词:3': 'Webpack',
        'B关键词:3': 'Vite',
        'A关键词:4': 'Jest',
        'B关键词:4': 'Cypress',
        'A关键词:5': 'TypeScript',
        'B关键词:5': 'JavaScript',
        'A关键词:6': 'GraphQL',
        'B关键词:6': 'REST',
        'A关键词:7': 'Webpack',
        'B关键词:7': 'Vite',
        'A关键词:8': 'Jest',
        'B关键词:8': 'Cypress',
    },
    [SmartComponentType.CIRCLE_ARROW]: {
        '组件标题:': '项目时间轴',
        '节点时间:1': '2023 Q1',
        '节点标题:1': '项目启动',
        '节点内容:1': '需求分析与规划',
        '关键词:1': '规划',
        '节点时间:2': '2023 Q2',
        '节点标题:2': '开发阶段',
        '节点内容:2': '核心功能开发',
        '关键词:2': '开发',
        '节点时间:3': '2023 Q3',
        '节点标题:3': '测试阶段',
        '节点内容:3': '系统测试与优化',
        '关键词:3': '测试',
        '节点时间:4': '2023 Q4',
        '节点标题:4': '上线准备',
        '节点内容:4': '部署与文档准备',
        '关键词:4': '部署',
        '节点时间:5': '2024 Q5',
        '节点标题:5': '正式上线',
        '节点内容:5': '系统正式运行',
        '关键词:5': '上线',
        '节点时间:6': '2024 Q6',
        '节点标题:6': '迭代优化6',
        '节点内容:6': '功能优化与升级6',
        '关键词:6': '优化6',
        '节点时间:7': '2024 Q7',
        '节点标题:7': '迭代优化7',
        '节点内容:7': '功能优化与升级7',
        '关键词:7': '优化7',
        '节点时间:8': '2024 Q8',
        '节点标题:8': '迭代优化8',
        '节点内容:8': '功能优化与升级8',
        '关键词:8': '优化8',
    },
    [SmartComponentType.KEY_DATA]: {
        '组件标题:': '关键数据',
        '数据:1': '100',
        '关键词:1': '数据1',
        '数据:2': '200',
        '关键词:2': '数据2',
        '数据:3': '300',
        '关键词:3': '数据3',
        '数据:4': '400',
        '关键词:4': '数据4',
        '数据:5': '500',
        '关键词:5': '数据5',
        '数据:6': '600',
        '关键词:6': '数据6',
        '数据:7': '700',
        '关键词:7': '数据7',
        '数据:8': '800',
        '关键词:8': '数据8',
    },
};

export const smartComponentContentJson = {
    page_type: '内容',
    data: {
        章节标题: '灾害威胁与挑战',
        章节序号: 1,
        内容标题: '当前防御薄弱点',
        内容总结: null,
        '列表标题:1': '建筑抗震短板',
        '列表内容:1':
            '我国既有建筑中约230亿平方米未达现行抗震标准，农村自建房抗震达标率仅31%，2024年云南地震中非标建筑损毁率达87%。',
        '列表标题:2': '预警覆盖盲区',
        '列表内容:2':
            '地震预警系统在西部山区覆盖率不足40%，2025年国家地震台网数据显示仍有12%县级行政区未完成预警终端部署。',
        '列表标题:3': '应急意识差距',
        '列表内容:3': '2024年全国防灾演练参与率城市为68%、农村仅29%，超半数受访者不知晓“伏地遮挡手抓牢“标准避险姿势。',
        '列表标题:4': '全国防灾演练参',
        '列表内容:4':
            '地震预警系统在西部山区覆盖率不足40%，2025年国家地震台网数据显示仍有12%县级行政区未完成预警终端部署。',
        '列表标题:5': '云南地震中非标',
        '列表内容:5':
            '我国既有建筑中约230亿平方米未达现行抗震标准，农村自建房抗震达标率仅31%，2024年云南地震中非标建筑损毁率达87%。',
        '列表标题:6': '未达现行抗震标准',
        '列表内容:6': '2024年全国防灾演练参与率城市为68%、农村仅29%，超半数受访者不知晓“伏地遮挡手抓牢“标准避险姿势。',
        '列表标题:7': '非标建筑损毁率',
        '列表内容:7': '2024年全国防灾演练参与率城市为68%、农村仅29%，超半数受访者不知晓“伏地遮挡手抓牢“标准避险姿势。',
        '可替换图片:1': 1741921294601455,
    },
    component_point: 3,
    selected_component_ids: [],
    component_id: 1726308029640743,

    graph_components: [
        {
            graph_component_id: 1741921294601455,
            graph_component_point: 5,
            graph_type: '时间轴图',
            graph_data: {
                '组件标题:': '地震时间轴',
                '节点时间:1': 'Q1',
                '节点标题:1': '启动',
                '节点内容:1': '市场调研',
                '关键词:1': '调研',
                '节点时间:2': 'Q2',
                '节点标题:2': '增长',
                '节点内容:2': '产品上线',
                '关键词:2': '上线',
                '节点时间:3': 'Q3',
                '节点标题:3': '目标',
                '节点内容:3': 'GMV50万',
                '关键词:3': '目标',
                '节点时间:4': 'Q4',
                '节点标题:4': '目标',
                '节点内容:4': 'GMV50万',
                '关键词:4': '目标',
                '节点时间:5': 'Q5',
                '节点标题:5': '目标',
                '节点内容:5': 'GMV50万',
                '关键词:5': '目标',
            },
        },
    ],
};
